import { ArcRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasArcPicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasArcPicker } from "./arc-picker";

let loadArcPick = !1;

export function bindArcCanvasPickerContribution(container) {
    loadArcPick || (loadArcPick = !0, container.bind(CanvasArcPicker).toDynamicValue((() => new DefaultCanvasArcPicker(resolveContainerBinding(container, ArcRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasArcPicker));
}
//# sourceMappingURL=arc-module.js.map
